<template>
  <div class="real_page" id="trendView">
    <div class="border_line text-14px pb-10px text-white">
      <!-- <el-tooltip content="打印">
        <i class="iconfont icon-print m-r-5 fz-18 cur-pointer m-l-10" @click="doPrint"> </i>
      </el-tooltip> -->
      <!-- <el-tooltip content="导出">
        <i class="iconfont icon-bg-excel m-r-5 fz-18 cur-pointer m-l-5" @click="exportToExcel">
        </i>
      </el-tooltip> -->
      <el-button size="small" @click="isShowPointDialog = true" type="primary">
        添加测点
      </el-button>
      <span class="ml-10px">状态：</span>
      <el-select
        v-model="search.status"
        @change="switchChange"
        popper-class="visualization-select-popper"
        class="ml-10px"
        style="width:100px;"
        size="small"
      >
        <el-option :value="0" label="实时"></el-option>
        <el-option :value="1" label="历史"></el-option>
      </el-select>
      <span class="ml-10px mr-5px">颗粒度：</span>
      <el-input
        placeholder="数值"
        v-model="search.interval"
        style="width:100px;"
        type="number"
        min="1"
        size="small"
      >
      </el-input>
      <el-select
        v-model="search.intervalUnit"
        slot="append"
        class="ml-5px"
        style="width:85px;"
        size="small"
        popper-class="visualization-select-popper"
      >
        <el-option
          v-for="(item, index) in dateDataUnitList"
          :key="`${item}${index}`"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <span class="ml-10px mr-5px">快速选取：</span>
      <el-select
        v-model="search.timeSpan"
        style="width: 120px;"
        @change="timeSpanChange"
        size="small"
        popper-class="visualization-select-popper"
      >
        <el-option
          v-for="(item, index) in spanData"
          :key="`${item}${index}`"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <span class="ml-10px mr-5px"
        >时间选择：
        <date-time
          :model.sync="search.time"
          model-name="search.time"
          value-format="YYYY-MM-DD HH:mm:ss"
          input-width="190px"
          :clearable="true"
          :disabledAfterToday="true"
          :key="updateTime"
        >
        </date-time>
      </span>
      <el-button type="primary" size="small" class="ml-10px search-btn" @click="searchHistoryTrend">
        搜索
      </el-button>
    </div>
    <select-point
      v-if="isShowPointDialog"
      :relatedPoints="trendTableData"
      :visible.sync="isShowPointDialog"
      :isSetMaxSelected="true"
      :maxCount="16"
      :appendToBody="true"
      @selectedPoint="handleSelect"
    />
  </div>
</template>

<script type="text/babel">
import DateTime from './dateTime'

const selectPoint = () => {
  return import('./selectPoints')
}

export default {
  props: {
    trendTableData: {
      type: Array,
      default: () => {
        return []
      },
    },
    updateTime: Number,
    search: {
      type: Object,
      default: () => {
        return {
          status: 0, // 实时/历史
          interval: 1, // 颗粒度数值
          intervalUnit: 0, // 颗粒度单位(秒、分、时、天)
          timeSpan: 0, // 快速选取数值
          time: [], // 开始与结束时间
        }
      },
    },
  },
  components: {
    DateTime,
    selectPoint,
  },
  data() {
    return {
      isShowPointDialog: false, // 是否显示添加测点弹窗
      dateDataUnitList: [
        {
          label: '秒',
          value: 0,
        },
        {
          label: '分钟',
          value: 1,
        },
        {
          label: '小时',
          value: 2,
        },
        {
          label: '天',
          value: 3,
        },
      ],
      condition: null,
      tableCondition: null,
      /** 快速选取的选项 */
      spanData: [
        {
          label: '最近10分钟',
          value: 0,
        },
        {
          label: '最近30分钟',
          value: 1,
        },
        {
          label: '最近1小时',
          value: 2,
        },
        {
          label: '最近4小时',
          value: 3,
        },
        {
          label: '最近8小时',
          value: 4,
        },
        {
          label: '最近1天',
          value: 5,
        },
        {
          label: '最近7天',
          value: 6,
        },
        {
          label: '最近30天',
          value: 7,
        },
      ],
      restoreCondition: {},
    }
  },
  methods: {
    // 打印
    doPrint() {
      this.$emit('on-print')
    },
    // 生成表格
    async exportToExcel() {},
    /* 处理测点弹窗点击确定后返回的测点数据 */
    handleSelect(measurePoints) {
      if (Array.isArray(measurePoints) && measurePoints.length > 0) {
        this.$emit('on-select', measurePoints, this.search)
      }
    },
    // 切换实时、历史模式(实时 = 0，历史 = 1)
    async switchChange(type) {
      this.$emit('on-switch', type)
    },
    /* 快速选取 */
    timeSpanChange() {
      this.search.time = [] // 搜索时间置为空
      const ts = this.computedTimeSpan(this.search.timeSpan)
      this.search.time[0] = moment()
        .subtract(ts.value, ts.date)
        .format('YYYY-MM-DD HH:mm:ss')
      this.search.time[1] = moment().format('YYYY-MM-DD HH:mm:ss')
      this.$emit('on-search', this.search)
    },
    /* 计算时间跨度(快速选取后，计算出开始/结束时间) */
    computedTimeSpan(span) {
      let time = null
      switch (span) {
        case 1:
          time = {
            value: 30,
            date: 'minutes',
          }
          break
        case 2:
          time = {
            value: 1,
            date: 'hours',
          }
          break
        case 3:
          time = {
            value: 4,
            date: 'hours',
          }
          break
        case 4:
          time = {
            value: 8,
            date: 'hours',
          }
          break
        case 5:
          time = {
            value: 1,
            date: 'days',
          }
          break
        case 6:
          time = {
            value: 7,
            date: 'days',
          }
          break
        case 7:
          time = {
            value: 30,
            date: 'days',
          }
          break
        default:
          time = {
            value: 10,
            date: 'minutes',
          }
          break
      }
      return time
    },
    searchHistoryTrend() {
      if (Array.isArray(this.search.time) && this.search.time.length > 0) {
        const startTime = new Date(this.search.time[0]).getTime()
        const endTime = new Date(this.search.time[1]).getTime()
        const gap = endTime - startTime > 30 * 24 * 60 * 60 * 1000 // 开始、结束时间跨度是否大于30天
        if (gap) {
          this.$message.warning('时间最大选择区间为30天!')
          return
        }
      }
      this.$emit('on-search', this.search)
    },
  },
}
</script>
<style scoped lang="scss">
::v-deep .el-switch {
  .el-switch__label {
    position: absolute;
    display: none;
    color: #fff;

    &.is-active {
      display: block;
    }

    &,
    .el-switch__core {
      width: 50px !important;
    }
  }

  .el-switch__label--left {
    left: 20px;
    z-index: 9;
  }

  .el-switch__label--right {
    left: -3px;
    z-index: 9;
  }
}

.icon_hover {
  &:hover {
    color: #31b6f9;
  }
}
</style>
